import React from 'react';
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { BiSolidMap } from "react-icons/bi"; 
import './Header.css';

const Header = () => {
  return (
    <div className="top-bar">
      <div className="container top-bar-container">
        <div className="left-info d-flex gap-4">
          <div className="info-item d-flex align-items-center">
            <FaPhoneAlt className="icon" />
            <a href="tel:+919560089567" style={{ color: 'white', textDecoration: 'none' }}>
  +91 9560089567
</a>
          </div>
          <div className="info-item d-flex align-items-center">
            <IoMdMail className="icon" />
            <span>info@fintechsmartsolutions.com</span>
          </div>
        </div>

        <div className="right-info info-item">
          <BiSolidMap className="icon" />
          <div className="address-text">
            <span>Office Space No. D-6, 1st and 2nd Floor,</span>
            <span>Sector 2, Noida, Uttar Pradesh, India</span>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Header;
